import React from 'react';
import { ShouldRender } from 'components/ShouldRender';
import { Text } from '../../../../typography/Text';
import { DiscardIcon } from '../../../../../assets/icons/DiscardIcon';
import styles from './styles.module.scss';

export const UploadedImage = ({ content, name, size, onRemove, remove = true }) => (
  <div className={styles.uploadedImage}>
    <img
      className={styles.image}
      src={content}
      alt={name}
    />

    <div className={styles.description}>
      <Text
        bold
        lightGray
        elipsis
      >
        {name}
      </Text>

      <Text
        small
        lightGray
      >
        {Math.round(size / 1000)}KB
      </Text>
    </div>

    <ShouldRender condition={!!remove}>
      <div className={styles.remove}>
        <DiscardIcon onClick={() => onRemove(name)} />
      </div>
    </ShouldRender>
  </div>
);
